import { InjectionToken } from "@angular/core";

export class AppSettings {
    production: boolean;
    baseHref: string = "";
    cookieAuthName: string = "";
    info: ApplicationInfo;
    kontakt: Kontakt;

    getUserReportUrl(lang: string): string {
        return "/" + lang + "/myreports/";
    }
}

export interface ApplicationInfo {
    product: string;
    version: string;
    fileVersion: string;
    copyright: string;
}

export interface Kontakt {
    namn: string;
    adress: string;
    postadress: string;
    telefon: string;
    epost: string;
    web: string;
}

export const APP_SETTINGS = new InjectionToken<AppSettings>("environment");
